module.exports = __webpack_public_path__ + "img/how-works-modal-image-02.6a2b6f4.svg";